import { getSignupDetails } from "service/auth";

export const FETCH_SIGNUP_DETAILS_SUCCESS = "FETCH_SIGNUP_DETAILS_SUCCESS";
export const FETCH_SIGNUP_DETAILS_FAILURE = "FETCH_SIGNUP_DETAILS_FAILURE";

export const fetchSignupDetails = () => {
  return async (dispatch) => {
    try {
      const { data = {}, success } = await getSignupDetails();
      if (success) {
        const preferredExamList =
          data?.preferred_exams?.length > 0 &&
          data.preferred_exams.map((exam) => ({
            value: exam.id,
            label: exam.name,
          }));
        dispatch({
          type: FETCH_SIGNUP_DETAILS_SUCCESS,
          payload: preferredExamList,
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_SIGNUP_DETAILS_FAILURE,
        payload: error,
      });
    }
  };
};
